import { useState } from "react";
import { db, auth } from "./firebase";
import {
  collection,
  getDocs,
  query,
  where,
  writeBatch,
  doc,
} from "firebase/firestore";

/**
 * Deletes ALL transactions for the current user (manual + Plaid).
 * Batches deletes in chunks of 500 with clear confirmations and progress.
 */
export default function DeleteMockTransactionsButton({
  label = "Delete All Transactions",
}) {
  const [deleting, setDeleting] = useState(false);
  const [status, setStatus] = useState("");

  const handleDeleteAll = async () => {
    const user = auth.currentUser;
    if (!user) {
      alert("You must be signed in.");
      return;
    }

    // Two-step confirmation
    if (
      !window.confirm(
        "Are you sure? This will permanently delete ALL of your transactions."
      )
    ) {
      return;
    }
    const typed = window.prompt(
      'Type DELETE to confirm removing ALL of your transactions.'
    );
    if (typed !== "DELETE") return;

    setDeleting(true);
    setStatus("Finding your transactions...");

    try {
      // Scope to current user's docs only
      const q = query(
        collection(db, "transactions"),
        where("userId", "==", user.uid)
      );

      const snapshot = await getDocs(q);
      const total = snapshot.size;

      if (total === 0) {
        setStatus("No transactions found for your account.");
        setDeleting(false);
        return;
      }

      setStatus(`Deleting ${total} transaction(s)...`);

      const docs = snapshot.docs;
      let deleted = 0;

      for (let i = 0; i < docs.length; i += 500) {
        const batch = writeBatch(db);
        const slice = docs.slice(i, i + 500);
        slice.forEach((d) => {
          batch.delete(doc(db, "transactions", d.id));
        });
        await batch.commit();
        deleted += slice.length;
        setStatus(`Deleted ${deleted} of ${total}...`);
      }

      setStatus(`✅ Deleted ${deleted} transaction(s).`);
    } catch (err) {
      console.error("Error deleting transactions:", err);
      setStatus("❌ Something went wrong. Check console for details.");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div>
      <button
        onClick={handleDeleteAll}
        disabled={deleting}
        style={{
          height: 40,
          padding: "0 12px",
          backgroundColor: "#b71c1c", // danger tone
          color: "#fff",
          border: "none",
          borderRadius: 8,
          cursor: deleting ? "not-allowed" : "pointer",
          whiteSpace: "nowrap",
        }}
        title="Danger: deletes ALL of your transactions"
      >
        {deleting ? "Deleting..." : label}
      </button>

      {status && (
        <div style={{ marginTop: 8, color: "#111" }}>
          {status}
        </div>
      )}
    </div>
  );
}